import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompact';

import { errorBoundary } from 'src/app/hocs';
import { getPathParams } from 'src/app/state/selectors';

import Renderer from '.';

function makeMapStateToProps() {
  return (ownProps: any) => {
    const cartId = getPathParams(ownProps, 'cartId');

    return {
      cartId,
    };
  };
}

export default compose(errorBoundary, setDisplayName('AccountUploadID'), connect(makeMapStateToProps, null))(Renderer);
